// src/frame/frameLoginStyles.js
import { styled } from "@mui/material/styles";

// Root는 전체 배경
export const Root = styled("div")(({ backgroundImg }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  //backgroundImage: `url(${backgroundImg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  background: "linear-gradient(to bottom, #F1F8FF, #E1F1FF)",
}));

// Wrapper는 로그인 박스 전체 (최대 크기 설정)
export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  backgroundColor: "#ffffffee",
  borderRadius: 4,
  overflow: "hidden",
  boxShadow: "0 0 20px #1E4AC029",
  maxWidth: 800,
  maxHeight: 400,
  width: "800px",
  height: "400px",
}));

// 왼쪽 이미지 영역
export const ImageWrapper = styled("div")(() => ({
  flex: 1,
  backgroundColor: "#f0f2f5",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  width: "400px",
}));

export const Image = styled("img")(() => ({
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
}));

// 오른쪽 폼 영역
export const FormWrapper = styled("div")(() => ({
  padding: 32,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "400px",
}));

export const LogoWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "left",
  marginBottom: 16,
}));

export const LogoImage = styled("img")(() => ({
  height: "26px",
  width: "125px",
}));
